import { t } from '../messages';
export function interactiveStatus(status: string) {
  switch (status) {
    case 'draft':
      return t('interactive.status.draft');
    case 'running':
      return t('interactive.status.running');
    case 'paused':
      return t('interactive.status.paused');
    case 'ended':
      return t('interactive.status.ended');
    default:
      return status;
  }
}
